import React from "react";
import { Link } from "react-router-dom";

const Home: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center px-6">
    <div className="max-w-2xl mx-auto flex flex-col items-center text-center">
      <h1 className="text-6xl font-bold font-display text-ink mb-6">
        Welcome to Exam Revision
      </h1>
      <p className="text-2xl font-body text-gray-600 mb-10 max-w-xl">
        Prepare for your exams with AI-powered quizzes, instant feedback, and smart tutoring.
        Practice, learn, and track your progress in a clean, easy-to-use interface.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 w-full items-center justify-center">
        <Link
          to="/register"
          className="bg-primary text-white font-semibold font-body py-3 px-10 rounded-lg hover:bg-ink transition-colors duration-200 min-w-[180px] text-center"
        >
          Get Started
        </Link>
        <Link
          to="/login"
          className="bg-transparent border border-primary text-primary font-semibold font-body py-3 px-10 rounded-lg hover:bg-lightbg transition-colors duration-200 min-w-[180px] text-center"
        >
          Login
        </Link>
      </div>
    </div>
  </div>
);

export default Home;
